import closeFixrOverlay from "./thunks/closeFixrOverlay";
import Fixr from "./components/Fixr/Fixr";
import FixrOverlayProps from "./FixerOverlayProps";
import styles from "./FixrOverlay.module.scss";

import { FunctionComponent, useRef } from "react";
import { Portal } from "react-portal";
import { useDispatch } from "react-redux";
import combineClasses from "helpers/combine-classes";
import React from "react";

const FixrOverlay: FunctionComponent<FixrOverlayProps> = (props): JSX.Element => {
    const dispatch = useDispatch();

    const wrapperElementRef = useRef<any>(null);

    const isActiveClass = props.state === "FIXR_OVERLAY" ? styles.is_active : undefined;
    const isClosingClass = props.state === "CLOSING_FIXR_OVERLAY" ? styles.is_closing : undefined;

    const closeOverlay = () => {
        dispatch(closeFixrOverlay(wrapperElementRef));
    };

    return (

        <Portal node={document && document.getElementById("wrapper")}>
            <div className={combineClasses(styles.outer, isActiveClass, isClosingClass)} onClick={closeOverlay}></div>
            <div className={combineClasses(styles.wrapper, isActiveClass, isClosingClass)} style={props.headerStyles} ref={wrapperElementRef}>
                <Fixr {...props} />
            </div>
        </Portal>
    );
};

export default FixrOverlay;